import React , {Suspense }from "react";
import HeaderNew from "../HeaderNew";
import FooterNew from "../FooterNew";
import Footer from "../Footer";
import Loader from "../Loader";
import LoadingPage from "../loader/LoadingPage";

const LayoutNew = ({ children }) => {
  return <>
    <HeaderNew/>
    <Suspense fallback={<LoadingPage/>} >
    {children}
    </Suspense>
    <Loader/>
    <Footer />
    <FooterNew/>
  </>;
};

export default LayoutNew;
